import React from 'react';
import PropTypes from 'prop-types';
import {fromJS, Map, List} from 'immutable';
import uuid from 'uuid/v4';
import Button from 'sg/Button/Button.react';
import TwoWayRow from './TwoWayRow.react';
import SupplementManagerModalButton from 'client/Supplements/SupplementManager/SupplementManagerModalButton.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';
import AuthoringTextInput from 'client/EditPage/V2/AuthoringTextInput/AuthoringTextInput.react';
import './two-way-editor.scss';

function createNewRow(index) {
  return fromJS({
    index: index,
    id: uuid(),
    statement: '',
    columns: {
      left: {
        id: uuid(),
        text: ''
      },
      right: {
        id: uuid(),
        text: ''
      }
    }
  });
}

export default class TwoWayEditor extends React.Component {
  static propTypes = {
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onBlur: PropTypes.func,
    onModelChange: PropTypes.func,
    validationErrors: PropTypes.instanceOf(Map)
  };

  constructor(props) {
    super(props);

    if (props.question.getRows().isEmpty()) {
      this.setupTwoWayDefaults();
    }
  }

  setupTwoWayDefaults() {
    const defaultRows = List()
      .setSize(3)
      .map((row, key) => createNewRow(key));
    const question = this.props.question.setRows(defaultRows);

    this.props.onModelChange(question);
  }

  onChange = (e) => {
    let question = this.props.question;
    let validation;
    if (e.target.name === 'headerLeft') {
      question = question.setHeaderLeft(e.target.value);
      validation = 'headerLeft';
    } else {
      question = question.setHeaderRight(e.target.value);
      validation = 'headerRight';
    }

    this.props.onModelChange(question, validation);
  };

  addRow = () => {
    const rows = this.props.question
      .getRows()
      .push(createNewRow(this.props.question.getRows().size))
      .sortBy((row) => row.get('index'))
      .map((row, index) => row.set('index', index));

    const updatedQuestion = this.props.question.setRows(rows);
    this.props.onModelChange(updatedQuestion, 'rows');
  };

  generateRows() {
    return this.props.question
      .getRows()
      .sortBy((row) => row.get('index', 0))
      .map((row, key) => {
        return (
          <TwoWayRow
            key={key}
            row={row}
            rowIndex={key}
            question={this.props.question}
            onBlur={this.props.onBlur}
            onModelChange={this.props.onModelChange}
            validationErrors={this.props.validationErrors}
          />
        );
      });
  }

  render() {
    const errors = this.props.validationErrors;
    const minimumRowError =
      errors.get('rows') && typeof errors.get('rows') === 'string' ? (
        <div className='a-form-input__error'>{errors.get('rows')}</div>
      ) : null;
    return (
      <div className='two-way-editor'>
        <div className='two-way-editor__headers'>
          <div className='two-way-editor__header two-way-editor__header--left'>
            <AuthoringTextInput
              displayAs='input'
              value={this.props.question.getHeaderLeft()}
              error={errors.get('headerLeft')}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              data-field-path='header_left'
              className='two-way-editor__header-input'
              label='Header Left'
              name='headerLeft'
            />
            <SupplementManagerModalButton
              className='two-way-editor__add-supplement-btn two-way-editor__add-supplement-btn--header two-way-editor__add-supplement-btn--header-left'
              color='blue'
              linkButton
              pathToProperty='header_left'
            />
          </div>
          <div className='two-way-editor__header two-way-editor__header--right'>
            <AuthoringTextInput
              displayAs='input'
              value={this.props.question.getHeaderRight()}
              error={errors.get('headerRight')}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              data-field-path='header_right'
              className='two-way-editor__header-input'
              label='Header Right'
              name='headerRight'
            />
            <SupplementManagerModalButton
              className='two-way-editor__add-supplement-btn two-way-editor__add-supplement-btn--header two-way-editor__add-supplement-btn--header-right'
              color='blue'
              linkButton
              pathToProperty='header_right'
            />
          </div>
        </div>
        <hr />
        <div className='two-way-editor__rows'>
          {minimumRowError}
          {this.generateRows()}
        </div>
        <hr />
        <Button onClick={this.addRow} color='green' text='New row' />
      </div>
    );
  }
}
